/* Veryplants tree count (2026-09-23).
   Refreshes every [data-vp-tree-count] element from the Sprout (GoodAPI) counter, the same endpoint
   the app's own "Your environmental impact" banner reads. If the request fails or returns something
   unexpected, the verified figure rendered by Liquid stays in place. Cart-drawer re-renders are
   covered by a debounced MutationObserver.
   Also records clicks on links to the tree-planting impact page (event vp_impact_link_click, with the
   placement the link sat in), added 2026-09-24. */
(function () {
  'use strict';
  if (window.__vpTreeCount) return;
  window.__vpTreeCount = true;
  /* Shared event helper (also defined in vp-tree-count.js; whichever loads first wins). Sends to every GA4
     property configured through gtag on the page, to Microsoft Clarity, and to Shopify customer events so a
     custom pixel can subscribe. Never throws. */
  if (!window.vpTrack) {
    window.vpTrack = function (name, params) {
      params = params || {};
      try { params.market = params.market || (window.Shopify && window.Shopify.country) || ''; } catch (e) {}
      /* Address every GA4 property the page configures (read from the gtag config calls). Without send_to, one of
         the two properties on veryplants.com ignores custom events and Google Ads remarketing receives them instead. */
      try {
        if (typeof window.gtag === 'function') {
          var ids = [];
          (window.dataLayer || []).forEach(function (x) { if (x && x[0] === 'config' && /^G-/.test(x[1]) && ids.indexOf(x[1]) === -1) ids.push(x[1]); });
          var p = {}; for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k]; }
          if (ids.length) p.send_to = ids;
          window.gtag('event', name, p);
        }
      } catch (e) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, params); } catch (e) {}
    };
  }

  var PLACEMENTS = [['.vp-trust', 'trust_strip'], ['.vp-tree-line', 'product_page'], ['.vp-tree-badge', 'cart_drawer'], ['.vp-impact', 'homepage_impact'], ['footer', 'footer'], ['.footer', 'footer']];
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="our-tree-planting-impact"]') : null;
    if (!a) return;
    var placement = 'other';
    for (var i = 0; i < PLACEMENTS.length; i++) { if (a.closest(PLACEMENTS[i][0])) { placement = PLACEMENTS[i][1]; break; } }
    window.vpTrack('vp_impact_link_click', { placement: placement });
  }, true);
  var KEY = 'vp_tree_count_v2';
  var TTL = 30 * 60 * 1000;
  var MIN = 1000;
  var MAX = 50000000;
  var locale = (document.documentElement.lang || 'en').replace('_', '-');
  var live = null;

  function fmt(n) {
    try { return n.toLocaleString(locale); } catch (e) { return String(n); }
  }

  function apply() {
    if (live === null) return;
    var els = document.querySelectorAll('[data-vp-tree-count]:not([data-live])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var base = parseInt(el.getAttribute('data-vp-tree-count'), 10) || 0;
      if (live < base * 0.5) continue; /* never replace the verified figure with something far lower */
      el.textContent = fmt(live);
      el.setAttribute('data-live', 'true');
      var wrap = el.closest ? el.closest('[data-vp-tree]') : null;
      var note = wrap ? wrap.querySelector('[data-vp-tree-note]') : null;
      if (note && note.getAttribute('data-live-text')) note.textContent = note.getAttribute('data-live-text');
    }
  }

  function remember(n) {
    try { sessionStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), n: n })); } catch (e) {}
  }

  function recall() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && c.n && Date.now() - c.ts < TTL) return c.n;
    } catch (e) {}
    return null;
  }

  function parse(html) {
    var m = html.match(/<span[^>]*>\s*([\d][\d,.\s]{2,})\s*<\/span>[\s\S]{0,120}?tree/i) ||
            html.match(/([\d][\d,.\s]{2,})\s*(?:<[^>]+>\s*)*trees?\s+planted/i);
    if (!m) return null;
    var n = parseInt(m[1].replace(/[^\d]/g, ''), 10);
    return (n >= MIN && n <= MAX) ? n : null;
  }

  function fetchLive() {
    if (!window.Shopify || !window.Shopify.shop || !window.fetch) return;
    var shop = window.Shopify.shop;
    var loc = window.Shopify.locale || 'en';
    var base = 'https://sprout-app.thegoodapi.com/app';
    fetch(base + '/assets/cdn_key?shop_name=' + encodeURIComponent(shop), { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (key) {
        key = key.trim();
        if (!/^[\w-]{8,64}$/.test(key)) throw new Error('key');
        return fetch(base + '/badges/tree_count?shop=' + encodeURIComponent(shop) + '&locale=' + encodeURIComponent(loc) + '&cdn_key=' + encodeURIComponent(key), { credentials: 'omit' });
      })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (html) {
        var n = parse(html);
        if (n) { live = n; remember(n); apply(); }
      })
      .catch(function () { /* keep the verified figure */ });
  }

  var timer;
  var observer = ('MutationObserver' in window) ? new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(apply, 200);
  }) : null;

  function start() {
    var cached = recall();
    if (cached) { live = cached; apply(); } else { fetchLive(); }
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
